/**
 * Add new comment and reply
 */

import { gql } from "@apollo/client";

export const visionWordsAndCommentsMutation = gql`
  mutation visionWordsAndCommentsMutation(
    $input: VisionWordsAndCommentsInput!
  ) {
    visionWordsAndCommentsMutation(input: $input) {
      id
      comment
      createdByUserId
      usersGivenLike {
        firstName
      }
      usersGivenLove {
        firstName
      }
      createdBy {
        firstName
        lastName
        profileImage {
          url
          fileName
        }
      }
      commentThread {
        comment
        createdAt
        createdBy {
          id
          firstName
          lastName
        }
      }
    }
  }
`;

export const getVisionComments = gql`
  query getVisionComments($visionId: ID) {
    getVisionComments(visionId: $visionId) {
      id
      comment
      isNew
      createdBy {
        id
        firstName
        lastName
        profileImage {
          url
          fileName
        }
      }
      createdAt
      usersGivenLike {
        firstName
      }
      usersGivenLove {
        firstName
      }
      commentThread {
        comment
        createdBy {
          id
          firstName
          lastName
          profileImage {
            url
            fileName
          }
        }
      }
    }
  }
`;
